// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import ContainerStyles from './container.styles';

export default function Container({
  children,
  fullWidth,
  flex,
  alignItems,
  justifyContent,
  className,
}) {
  return (
    <ContainerStyles
      fullWidth={fullWidth}
      flex={flex}
      alignItems={alignItems}
      justifyContent={justifyContent}
      className={`container ${className}`}
    >
      {children}
    </ContainerStyles>
  );
}

Container.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  flex: PropTypes.bool,
  alignItems: PropTypes.string,
  justifyContent: PropTypes.string,
  className: PropTypes.string,
};

Container.defaultProps = {
  children: '',
  fullWidth: false,
  flex: false,
  alignItems: '',
  justifyContent: '',
  className: '',
};
